var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoTask(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 68,
    viewBox: "0 0 53 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6371 2.12678C39.3187 0.7673 37.5057 0 35.612 0H7.05242C5.182 0 3.38819 0.80598 2.06561 2.24063C0.74302 3.67529 0 5.62109 0 7.65V60.35C0 62.3789 0.74302 64.3247 2.06561 65.7594C3.38819 67.194 5.182 68 7.05242 68H45.9476C47.818 68 49.6118 67.194 50.9344 65.7594C52.257 64.3247 53 62.3789 53 60.35V17.7118C53 15.8925 52.2917 14.1446 51.0251 12.8386L40.6371 2.12678Z",
    fill: "#DFE8FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#092682"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 14,
    width: 21,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 51,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#092682"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 51,
    width: 16,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 23,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#092682"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 23,
    width: 32,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 32,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#092682"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 32,
    width: 24,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 42,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#092682"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 42,
    width: 23,
    height: 3,
    rx: 1.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTask);
export default __webpack_public_path__ + "static/media/no-task.fbde6dd4312c47ab96925741476e1162.svg";
export { ForwardRef as ReactComponent };